import type { Person } from "../api/typen";

/** Farbe je Person (F12): feste Reihenfolge der Mitglieder, wie die API sie liefert (nach Beitritt);
 *  „Gemeinsam“ hat die dritte Farbe. Nie alphabetisch, damit eine Person ihre Farbe behaelt. */
const FARBEN = [
  "bg-pg-person-1-soft text-pg-person-1",
  "bg-pg-person-2-soft text-pg-person-2",
  "bg-pg-person-3-soft text-pg-person-3",
];
export function personFarbe(personen: Pick<Person, "id">[] | undefined, id: string | null | undefined, gemeinsam?: boolean): string {
  if (gemeinsam) return FARBEN[2] ?? "";
  const i = (personen ?? []).findIndex((p) => p.id === id);
  return FARBEN[i < 0 ? 0 : i % 2] ?? "";
}
